import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css'

const Footer = () => {
    return (
        <div className="foot">
            <Container>
                <Row>
                    <Col>
                        Logo
                        Everyday is a new day for us and we work really hard to satisfy our customer everywhere.
                    </Col>
                    <Col>
                        <h5>RECENT POSTS</h5>
                        <div><iframe src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FEyeofchina&tabs=timeline&width=340&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId" width="340" height="200" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'></iframe></div>
                    </Col>
                    <Col>
                        <h5>PHOTO GALLERY</h5>
                        <div data-mc-src="6b45f007-c4fa-4f01-a8fc-4523489e444e#instagram"></div>
                    </Col>
                    <Col>
                        <h5>USEFUL LINKS</h5>
                        <ul>
                            <li>About Us</li>
                            <li>Services</li>
                            <li>Projects</li>
                            <li>Contact</li>
                        </ul>

                    </Col>

                </Row>
                <Row>
                    <Col>
                        <hr />
                        <div className="footer-icons">
                            <a href="https://www.facebook.com/Eyeofchina/" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://www.instagram.com/eyeofchina/" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                            <a href="#" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
                            <a href="https://wa.me/+27632648040/?text=I came across your website" target="blank"><i className="fab fa-whatsapp icons"></i></a>
                            <a href="#" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
                        </div>

                        <hr />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;